import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { requestProducts } from 'src/redux/products/thunks/requestProducts';
import type { SelectedSortOption, SortOption, SortOptionValue } from 'src/types';
import { getSelectedSortOption } from './reducerHelpers/getSelectedSortOption';

export interface FilterMenuState {
  sortingOptions: SortOption[];
  selectedSortOption: SelectedSortOption;
}

export const initialState: FilterMenuState = {
  sortingOptions: [],
  selectedSortOption: null,
};

export const { reducer, actions } = createSlice({
  name: 'filterMenu',
  initialState,
  reducers: {
    selectSortOption: (state, action: PayloadAction<SortOptionValue>) => {
      state.selectedSortOption =
        state.sortingOptions.find((option) => option.id === action.payload) || null;
    },
    resetSelectedSortOption: (state: FilterMenuState) => {
      state.selectedSortOption = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(requestProducts.fulfilled, (state, { payload }) => {
      if (payload.data?.sortingOptions) {
        state.sortingOptions = payload.data.sortingOptions;
        state.selectedSortOption = getSelectedSortOption(payload.data.sortingOptions);
      }
    });
  },
});
